import {FormattedMessage, injectIntl} from "react-intl";
import {nfmsPost} from "../../handler/NfmsClient";
import React, {useEffect, useState} from "react";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Select, {SelectOption} from "@amzn/meridian/select";
import Row from "@amzn/meridian/row";
import Input from "@amzn/meridian/input";
import {ALERT_TYPES, CONFIG_TYPES, GROK_FIELD_TYPES} from "../../Constants";
import Button from "@amzn/meridian/button";
import Tag from "@amzn/meridian/tag";
import {getErrorAlertObjectFromResponse} from "../../Utils";
import Alert from "@amzn/meridian/alert";
import {fetchTemplates} from "../../NetworkUtils";
import Breadcrumb, { BreadcrumbGroup } from "@amzn/meridian/breadcrumb"
import {CREATE_FEATURES_BASE_ROUTE} from "../util/RouteConstants";

const GrokConfiguration = (props) => {

    const [grokTemplate, setGrokTemplate] = useState();
    const [grokTemplates, setGrokTemplates] = useState([]);
    const [configName, setConfigName] = useState();
    const [fieldName, setFieldName] = useState();
    const [fieldType, setFieldType] = useState();
    const [showMcmButton, setShowMcmButton] = useState(false);
    const [fields, setFields] = useState([]);
    const [historyProps, setHistoryProps] = useState([{featureId: "", configId: "", mcmId: ""}]);
    const [alert, setAlert] = useState({visible: false, text:"", type:""})
    const warningAlert = {visible: true, text: "Create Grok Config request received.", type:ALERT_TYPES.WARNING};
    const successAlert = {visible: true, text: "Successfully created Grok Config", type:ALERT_TYPES.SUCCESS};

    useEffect(() => {
        try {
            setHistoryProps({
                featureId: props.location.state.featureId,
                configId: props.location.state.configId,
                mcmId: props.location.state.mcmId
            });
            setGrokTemplate(props.location.state.template);
            setConfigName(props.location.state.configName);
            setFields(props.location.state.fields ? props.location.state.fields : []);
        } catch(error) {}

        fetchTemplates(CONFIG_TYPES.GROK).then(response => setGrokTemplates(response));
    }, []);

    useEffect(() => {
        if (!historyProps || !historyProps.mcmId) {
            setShowMcmButton(true);
        }
    }, [historyProps]);

    const removeField = (fieldToBeRemoved) => {
        const fieldsCopy = fields.filter(field => {return field !== fieldToBeRemoved;})
        setFields(fieldsCopy);
    }

    const addField = () => {
        const newField = {name: fieldName, type: fieldType};
        const fieldsCopy = Array.from(fields);
        fieldsCopy.push(newField);
        setFields(fieldsCopy);
    }

    const createConfig = () => {
        setAlert(warningAlert);
        const params = {
            grokConfiguration: {
                featureId: historyProps.featureId,
                configurationId: historyProps.configId,
                configName: configName,
                template: grokTemplate,
                mcmId: historyProps.mcmId,
                fields: fields
            }
        };
        (async ()=>{
            nfmsPost("CreateGrokConfiguration", params)
                .then((response) => {
                    if (response.status === 200) {
                        setAlert(successAlert);
                    }
                })
                .catch((response) => {
                    setAlert(getErrorAlertObjectFromResponse(response));
                })
        })();
    }

    return (
        <div className="App">
            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <BreadcrumbGroup>
                        <Breadcrumb href={`#${CREATE_FEATURES_BASE_ROUTE}`}>
                            <FormattedMessage id="createConfig.heading" defaultMessage="Create New Configuration"/>
                        </Breadcrumb>
                        <Breadcrumb href={"#"}>
                            <FormattedMessage id="grokConfig.heading" defaultMessage="Create New Grok Configuration"/>
                        </Breadcrumb>
                    </BreadcrumbGroup>
                </Column>
            </Row>
            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="medium none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="grokConfig.template" defaultMessage="Template"/>
                    </Text>
                    <Select value={grokTemplate} onChange={setGrokTemplate} placeholder="Select Template" width={400}>
                        {grokTemplates.map(template => (
                            <SelectOption label={template} value={template} key={template} />
                        ))}
                    </Select>
                </Column>
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="grokConfig.configName" defaultMessage="grok Config Name"/>
                    </Text>
                    <Input id="config-name" value={configName} width={400}
                           onChange={setConfigName} type="text" placeholder="Enter grok Config name"/>
                </Column>
            </Row>

            {showMcmButton ?
                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="grokConfig.mcm" defaultMessage="MCM Id"/>
                        </Text>
                        <Input id="mcm-input" value={historyProps.mcmId}
                               onChange={id => setHistoryProps({...historyProps, mcmId: id})}
                               type="text" placeholder="Enter MCM Id" width={400}/>
                    </Column>
                </Row>
                : null}

            <Row alignmentVertical="top" spacingInset="large large small none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="grokConfig.fieldName" defaultMessage="Field Name"/>
                    </Text>
                    <Input id="field-name" value={fieldName} width={150}
                           onChange={setFieldName} type="text" placeholder="Field Name"/>
                </Column>
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="grokConfig.fieldType" defaultMessage="Field Type"/>
                    </Text>
                    <Select value={fieldType} onChange={setFieldType} placeholder="Field Type" width={130}>
                        {Object.entries(GROK_FIELD_TYPES).map(([key, value]) => (
                            <SelectOption label={key} value={value} key={key} />
                        ))}
                    </Select>
                </Column>
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="grokConfig.addButton" defaultMessage="."/>
                    </Text>
                    <Button type="secondary" onClick={() => addField()}>
                        <FormattedMessage id="grokConfig.addButton" defaultMessage="Add Field"/>
                    </Button>
                </Column>
            </Row>

            <Row alignmentVertical="top" spacingInset="small small small none" wrap="down">
                {fields.map(field => (
                    <Tag type="neutral" key={field.name} onClose={() => removeField(field)}>
                        {field.name + " (" + field.type + ")"}
                    </Tag>
                ))}
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="xlarge large large none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Button onClick={createConfig}>
                        <FormattedMessage id="grokConfig.create" defaultMessage="Create Config"/>
                    </Button>
                </Column>
            </Row>
            <Row alignmentVertical="top" spacingInset="none none medium none">
                {alert.visible ? <Alert type={alert.type}>{alert.text}</Alert> : null}
            </Row>
        </div>
    );
}

export default injectIntl(GrokConfiguration);


// WEBPACK FOOTER //
// ./src/components/create-config/GrokConfiguration.js